const FooterComponent = () => {


    return (
        <footer>
            <span className="my-footer">
                Aditya Hotel | All Right Reserved &copy; {new Date().getFullYear()}
            </span>
        </footer>
    );
};

export default FooterComponent;